// Country flag icon mapping utility
export const getCountryFlag = (countryName: string): string => {
  const flagMap: Record<string, string> = {
    // German country names (primary - from SAP data)
    'Deutschland': '🇩🇪',
    'Österreich': '🇦🇹',
    'Schweiz': '🇨🇭',
    'Liechtenstein': '🇱🇮',
    'Frankreich': '🇫🇷',
    'Italien': '🇮🇹',
    'Spanien': '🇪🇸',
    'Portugal': '🇵🇹',
    'Niederlande': '🇳🇱',
    'Belgien': '🇧🇪',
    'Luxemburg': '🇱🇺',
    'Monaco': '🇲🇨',
    'Andorra': '🇦🇩',
    'San Marino': '🇸🇲',
    'Vatikanstadt': '🇻🇦',
    'Vereinigtes Königreich': '🇬🇧',
    'Großbritannien': '🇬🇧',
    'England': '🇬🇧',
    'Schottland': '🇬🇧',
    'Wales': '🇬🇧',
    'Nordirland': '🇬🇧',
    'Irland': '🇮🇪',
    'Isle of Man': '🇮🇲',
    'Norwegen': '🇳🇴',
    'Schweden': '🇸🇪',
    'Dänemark': '🇩🇰',
    'Finnland': '🇫🇮',
    'Island': '🇮🇸',
    'Färöer': '🇫🇴',
    'Grönland': '🇬🇱',
    'Polen': '🇵🇱',
    'Tschechien': '🇨🇿',
    'Tschechische Republik': '🇨🇿',
    'Slowakei': '🇸🇰',
    'Ungarn': '🇭🇺',
    'Slowenien': '🇸🇮',
    'Kroatien': '🇭🇷',
    'Bosnien und Herzegowina': '🇧🇦',
    'Serbien': '🇷🇸',
    'Montenegro': '🇲🇪',
    'Nordmazedonien': '🇲🇰',
    'Albanien': '🇦🇱',
    'Kosovo': '🇽🇰',
    'Litauen': '🇱🇹',
    'Lettland': '🇱🇻',
    'Estland': '🇪🇪',
    'Rumänien': '🇷🇴',
    'Bulgarien': '🇧🇬',
    'Griechenland': '🇬🇷',
    'Türkei': '🇹🇷',
    'Zypern': '🇨🇾',
    'Malta': '🇲🇹',
    'Russland': '🇷🇺',
    'Ukraine': '🇺🇦',
    'Belarus': '🇧🇾',
    'Weißrussland': '🇧🇾',
    'Moldau': '🇲🇩',
    'Georgien': '🇬🇪',
    'Armenien': '🇦🇲',
    'Aserbaidschan': '🇦🇿',
    'Kasachstan': '🇰🇿',
    'China': '🇨🇳',
    'Japan': '🇯🇵',
    'Südkorea': '🇰🇷',
    'Nordkorea': '🇰🇵',
    'Indien': '🇮🇳',
    'Pakistan': '🇵🇰',
    'Bangladesch': '🇧🇩',
    'Sri Lanka': '🇱🇰',
    'Thailand': '🇹🇭',
    'Vietnam': '🇻🇳',
    'Malaysia': '🇲🇾',
    'Singapur': '🇸🇬',
    'Indonesien': '🇮🇩',
    'Philippinen': '🇵🇭',
    'Australien': '🇦🇺',
    'Neuseeland': '🇳🇿',
    'Vereinigte Staaten': '🇺🇸',
    'USA': '🇺🇸',
    'Kanada': '🇨🇦',
    'Mexiko': '🇲🇽',
    'Brasilien': '🇧🇷',
    'Argentinien': '🇦🇷',
    'Chile': '🇨🇱',
    'Kolumbien': '🇨🇴',
    'Venezuela': '🇻🇪',
    'Peru': '🇵🇪',
    'Ecuador': '🇪🇨',
    'Uruguay': '🇺🇾',
    'Paraguay': '🇵🇾',
    'Bolivien': '🇧🇴',
    'Israel': '🇮🇱',
    'Jordanien': '🇯🇴',
    'Libanon': '🇱🇧',
    'Syrien': '🇸🇾',
    'Irak': '🇮🇶',
    'Iran': '🇮🇷',
    'Saudi-Arabien': '🇸🇦',
    'Vereinigte Arabische Emirate': '🇦🇪',
    'Katar': '🇶🇦',
    'Kuwait': '🇰🇼',
    'Bahrain': '🇧🇭',
    'Oman': '🇴🇲',
    'Jemen': '🇾🇪',
    'Ägypten': '🇪🇬',
    'Libyen': '🇱🇾',
    'Tunesien': '🇹🇳',
    'Algerien': '🇩🇿',
    'Marokko': '🇲🇦',
    'Sudan': '🇸🇩',
    'Äthiopien': '🇪🇹',
    'Südafrika': '🇿🇦',
    'Nigeria': '🇳🇬',
    'Kenia': '🇰🇪',
    'Ghana': '🇬🇭',

    // English country names (fallback for translated content)
    'Germany': '🇩🇪',
    'United Kingdom': '🇬🇧',
    'UK': '🇬🇧',
    'Britain': '🇬🇧',
    'Poland': '🇵🇱',
    'Switzerland': '🇨🇭',
    'France': '🇫🇷',
    'Italy': '🇮🇹',
    'Spain': '🇪🇸',
    'Netherlands': '🇳🇱',
    'Belgium': '🇧🇪',
    'Austria': '🇦🇹',
    'Sweden': '🇸🇪',
    'Norway': '🇳🇴',
    'Denmark': '🇩🇰',
    'Finland': '🇫🇮',
    'Ireland': '🇮🇪',
    'Czech Republic': '🇨🇿',
    'Hungary': '🇭🇺',
    'Slovakia': '🇸🇰',
    'Slovenia': '🇸🇮',
    'Croatia': '🇭🇷',
    'Romania': '🇷🇴',
    'Bulgaria': '🇧🇬',
    'Greece': '🇬🇷',
    'Turkey': '🇹🇷',
    'Russia': '🇷🇺',
    'Lithuania': '🇱🇹',
    'Latvia': '🇱🇻',
    'Estonia': '🇪🇪',
    
    // Asia Pacific countries
    'India': '🇮🇳',
    'Australia': '🇦🇺',
    'South Korea': '🇰🇷',
    'Korea': '🇰🇷',
    'Singapore': '🇸🇬',
    'Philippines': '🇵🇭',
    'Indonesia': '🇮🇩',
    'Taiwan': '🇹🇼',
    'Hong Kong': '🇭🇰',
    'New Zealand': '🇳🇿',
    'Bangladesh': '🇧🇩',
    'Myanmar': '🇲🇲',
    'Cambodia': '🇰🇭',
    'Laos': '🇱🇦',
    'Mongolia': '🇲🇳',
    'Kazakhstan': '🇰🇿',
    'Uzbekistan': '🇺🇿',
    
    // Americas
    'United States': '🇺🇸',
    'America': '🇺🇸',
    'Canada': '🇨🇦',
    'Brazil': '🇧🇷',
    'Mexico': '🇲🇽',
    'Argentina': '🇦🇷',
    'Colombia': '🇨🇴',
    'Bolivia': '🇧🇴',
    'Costa Rica': '🇨🇷',
    'Panama': '🇵🇦',
    'Guatemala': '🇬🇹',
    'Honduras': '🇭🇳',
    'El Salvador': '🇸🇻',
    'Nicaragua': '🇳🇮',
    'Dominican Republic': '🇩🇴',
    'Jamaica': '🇯🇲',
    'Cuba': '🇨🇺',
    'Puerto Rico': '🇵🇷',
    
    // Middle East & Africa
    'South Africa': '🇿🇦',
    'Egypt': '🇪🇬',
    'Kenya': '🇰🇪',
    'Morocco': '🇲🇦',
    'Tunisia': '🇹🇳',
    'Algeria': '🇩🇿',
    'Ethiopia': '🇪🇹',
    'Tanzania': '🇹🇿',
    'Uganda': '🇺🇬',
    'Zimbabwe': '🇿🇼',
    'Botswana': '🇧🇼',
    'Namibia': '🇳🇦',
    'UAE': '🇦🇪',
    'United Arab Emirates': '🇦🇪',
    'Saudi Arabia': '🇸🇦',
    'Qatar': '🇶🇦',
    'Jordan': '🇯🇴',
    'Lebanon': '🇱🇧',
    'Syria': '🇸🇾',
    'Iraq': '🇮🇶',
    
    // Additional Manufacturing Hubs
    'Taiwan Province': '🇹🇼',
    'Macau': '🇲🇴',
    'Luxembourg': '🇱🇺',
    'Iceland': '🇮🇸',
    'Cyprus': '🇨🇾',
    'Vatican': '🇻🇦',
  };

  // Return the flag emoji or fallback to generic flag
  return flagMap[countryName] || '🏳️';
};

// Alternative using Unicode flag sequences for better compatibility
export const getCountryFlagUnicode = (countryName: string): string => {
  const flagMap: Record<string, string> = {
    // European countries
    'Germany': '\u{1F1E9}\u{1F1EA}',
    'United Kingdom': '\u{1F1EC}\u{1F1E7}',
    'UK': '\u{1F1EC}\u{1F1E7}',
    'Britain': '\u{1F1EC}\u{1F1E7}',
    'Poland': '\u{1F1F5}\u{1F1F1}',
    'Switzerland': '\u{1F1E8}\u{1F1ED}',
    'France': '\u{1F1EB}\u{1F1F7}',
    'Italy': '\u{1F1EE}\u{1F1F9}',
    'Spain': '\u{1F1EA}\u{1F1F8}',
    'Netherlands': '\u{1F1F3}\u{1F1F1}',
    'Belgium': '\u{1F1E7}\u{1F1EA}',
    'Austria': '\u{1F1E6}\u{1F1F9}',
    'Sweden': '\u{1F1F8}\u{1F1EA}',
    'Norway': '\u{1F1F3}\u{1F1F4}',
    'Denmark': '\u{1F1E9}\u{1F1F0}',
    'Finland': '\u{1F1EB}\u{1F1EE}',
    'Ireland': '\u{1F1EE}\u{1F1EA}',
    'Portugal': '\u{1F1F5}\u{1F1F9}',
    'Czech Republic': '\u{1F1E8}\u{1F1FF}',
    'Hungary': '\u{1F1ED}\u{1F1FA}',
    'Slovakia': '\u{1F1F8}\u{1F1F0}',
    'Slovenia': '\u{1F1F8}\u{1F1EE}',
    'Croatia': '\u{1F1ED}\u{1F1F7}',
    'Romania': '\u{1F1F7}\u{1F1F4}',
    'Bulgaria': '\u{1F1E7}\u{1F1EC}',
    'Greece': '\u{1F1EC}\u{1F1F7}',
    'Turkey': '\u{1F1F9}\u{1F1F7}',
    'Russia': '\u{1F1F7}\u{1F1FA}',
    'Ukraine': '\u{1F1FA}\u{1F1E6}',
    
    // Asia Pacific countries
    'Japan': '\u{1F1EF}\u{1F1F5}',
    'China': '\u{1F1E8}\u{1F1F3}',
    'India': '\u{1F1EE}\u{1F1F3}',
    'Australia': '\u{1F1E6}\u{1F1FA}',
    'South Korea': '\u{1F1F0}\u{1F1F7}',
    'Korea': '\u{1F1F0}\u{1F1F7}',
    'Singapore': '\u{1F1F8}\u{1F1EC}',
    'Malaysia': '\u{1F1F2}\u{1F1FE}',
    'Thailand': '\u{1F1F9}\u{1F1ED}',
    'Vietnam': '\u{1F1FB}\u{1F1F3}',
    'Philippines': '\u{1F1F5}\u{1F1ED}',
    'Indonesia': '\u{1F1EE}\u{1F1E9}',
    'Taiwan': '\u{1F1F9}\u{1F1FC}',
    'Hong Kong': '\u{1F1ED}\u{1F1F0}',
    'New Zealand': '\u{1F1F3}\u{1F1FF}',
    
    // Americas
    'United States': '\u{1F1FA}\u{1F1F8}',
    'USA': '\u{1F1FA}\u{1F1F8}',
    'America': '\u{1F1FA}\u{1F1F8}',
    'Canada': '\u{1F1E8}\u{1F1E6}',
    'Brazil': '\u{1F1E7}\u{1F1F7}',
    'Mexico': '\u{1F1F2}\u{1F1FD}',
    'Argentina': '\u{1F1E6}\u{1F1F7}',
    'Chile': '\u{1F1E8}\u{1F1F1}',
    'Colombia': '\u{1F1E8}\u{1F1F4}',
    'Peru': '\u{1F1F5}\u{1F1EA}',
    
    // Middle East & Africa
    'South Africa': '\u{1F1FF}\u{1F1E6}',
    'Egypt': '\u{1F1EA}\u{1F1EC}',
    'Nigeria': '\u{1F1F3}\u{1F1EC}',
    'Israel': '\u{1F1EE}\u{1F1F1}',
    'UAE': '\u{1F1E6}\u{1F1EA}',
    'United Arab Emirates': '\u{1F1E6}\u{1F1EA}',
    'Saudi Arabia': '\u{1F1F8}\u{1F1E6}',
  };

  // Return the flag emoji or fallback to generic flag
  return flagMap[countryName] || '\u{1F3F3}\u{FE0F}';
};

// Get country code for potential API integrations
export const getCountryCode = (countryName: string): string => {
  const codeMap: Record<string, string> = {
    // European countries
    'Germany': 'DE',
    'United Kingdom': 'GB',
    'UK': 'GB',
    'Britain': 'GB',
    'Poland': 'PL',
    'Switzerland': 'CH',
    'France': 'FR',
    'Italy': 'IT',
    'Spain': 'ES',
    'Netherlands': 'NL',
    'Belgium': 'BE',
    'Austria': 'AT',
    'Sweden': 'SE',
    'Norway': 'NO',
    'Denmark': 'DK',
    'Finland': 'FI',
    'Ireland': 'IE',
    'Portugal': 'PT',
    'Czech Republic': 'CZ',
    'Hungary': 'HU',
    'Slovakia': 'SK',
    'Slovenia': 'SI',
    'Croatia': 'HR',
    'Romania': 'RO',
    'Bulgaria': 'BG',
    'Greece': 'GR',
    'Turkey': 'TR',
    'Russia': 'RU',
    'Ukraine': 'UA',
    'Belarus': 'BY',
    'Lithuania': 'LT',
    'Latvia': 'LV',
    'Estonia': 'EE',
    
    // Asia Pacific countries
    'Japan': 'JP',
    'China': 'CN',
    'India': 'IN',
    'Australia': 'AU',
    'South Korea': 'KR',
    'Korea': 'KR',
    'Singapore': 'SG',
    'Malaysia': 'MY',
    'Thailand': 'TH',
    'Vietnam': 'VN',
    'Philippines': 'PH',
    'Indonesia': 'ID',
    'Taiwan': 'TW',
    'Hong Kong': 'HK',
    'New Zealand': 'NZ',
    'Bangladesh': 'BD',
    'Pakistan': 'PK',
    'Sri Lanka': 'LK',
    'Myanmar': 'MM',
    'Cambodia': 'KH',
    'Laos': 'LA',
    'Mongolia': 'MN',
    'Kazakhstan': 'KZ',
    'Uzbekistan': 'UZ',
    
    // Americas
    'United States': 'US',
    'USA': 'US',
    'America': 'US',
    'Canada': 'CA',
    'Brazil': 'BR',
    'Mexico': 'MX',
    'Argentina': 'AR',
    'Chile': 'CL',
    'Colombia': 'CO',
    'Peru': 'PE',
    'Venezuela': 'VE',
    'Ecuador': 'EC',
    'Uruguay': 'UY',
    'Paraguay': 'PY',
    'Bolivia': 'BO',
    'Costa Rica': 'CR',
    'Panama': 'PA',
    'Guatemala': 'GT',
    'Honduras': 'HN',
    'El Salvador': 'SV',
    'Nicaragua': 'NI',
    'Dominican Republic': 'DO',
    'Jamaica': 'JM',
    'Cuba': 'CU',
    'Puerto Rico': 'PR',
    
    // Middle East & Africa
    'South Africa': 'ZA',
    'Egypt': 'EG',
    'Nigeria': 'NG',
    'Kenya': 'KE',
    'Morocco': 'MA',
    'Tunisia': 'TN',
    'Algeria': 'DZ',
    'Ghana': 'GH',
    'Ethiopia': 'ET',
    'Tanzania': 'TZ',
    'Uganda': 'UG',
    'Zimbabwe': 'ZW',
    'Botswana': 'BW',
    'Namibia': 'NA',
    'Israel': 'IL',
    'UAE': 'AE',
    'United Arab Emirates': 'AE',
    'Saudi Arabia': 'SA',
    'Qatar': 'QA',
    'Kuwait': 'KW',
    'Bahrain': 'BH',
    'Oman': 'OM',
    'Jordan': 'JO',
    'Lebanon': 'LB',
    'Syria': 'SY',
    'Iraq': 'IQ',
    'Iran': 'IR',
    
    // Additional regions
    'Taiwan Province': 'TW',
    'Macau': 'MO',
    'Luxembourg': 'LU',
    'Monaco': 'MC',
    'Liechtenstein': 'LI',
    'Iceland': 'IS',
    'Malta': 'MT',
    'Cyprus': 'CY',
    'Andorra': 'AD',
    'San Marino': 'SM',
    'Vatican': 'VA',
  };

  return codeMap[countryName] || '';
};
